import React from 'react';
import { Box, Text } from '@rsos/components/capstone/base';

const NoUsers = () => {
  return (
    <Box align="center" justify="center" height="100%" pb={100}>
      <Box align="center" justify="center">
        <Text color="primaryText" size="small" mb={'12px'}>
          You currently have no users on the list.
        </Text>
        <Text color="primaryText" size="small">
          Please click “Add User” to get started.
        </Text>
      </Box>
    </Box>
  );
};

export default NoUsers;
